import $ from 'jquery';

const HeadingsAnim = (el) => {
    const $el = $(el);
    $(function () {
    $el.animate({opacity: 1}, 1000);
    });
};

export default HeadingsAnim;
